<template>
  <div>
    <v-row>
      <v-col class="col4">
        <h2>Previous invoices for this customer</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col12">
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th class="text-left">Number</th>
                <th class="text-left">
                  <span class="link" @click="reorderDate">Date</span>
                </th>
                <th class="text-left">Site</th>
                <th class="text-left">Value</th>
                <th class="text-left">Vat</th>
                <th class="text-left">O/S</th>
                <th class="text-left">Paid</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="invoice in orderedInvoices"
                :key="invoice.id"
              >
                <td>{{ invoice.statusLetter }}</td>
                <td>{{ invoice.invoiceNumber }}</td>
                <td>{{ invoice.date | tinyDate }}</td>
                <td>{{ invoice.siteLocation }}</td>
                <td>{{ invoice.value | priceInPounds | currency }}</td>
                <td>{{ invoice.vat | priceInPounds | currency }}</td>
                <td>{{ invoice.outstanding | priceInPounds | currency }}</td>
                <td>{{ invoice.amountPaid | priceInPounds | currency }}</td>
                <td>
                  <router-link
                    v-if="userPermissions.includes(4)"
                    custom
                    v-slot="{ navigate }"
                    :to="`/invoices/view-draft/${invoice.id}`">
                    <v-btn
                      title="View"
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                        View
                    </v-btn>
                  </router-link>
                  <router-link
                    v-else
                    custom
                    v-slot="{ navigate }"
                    :to="`/invoices/print-view/${invoice.id}`">
                    <v-btn
                      title="View"
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                        View
                    </v-btn>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row class="pb-5">
      <v-col class="text-right">
        <v-btn @click="loadInvoices" small>Load More</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'CustomerInfoInvoices',
  props: [
    'customerId',
  ],
  data() {
    return {
     invoices: [],
     count: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    orderedInvoices() {
      return this.invoices;
    },
    userPermissions() {
      return this.$store.state.userPermissions;
    },
  },
  methods: {
    loadInvoices() {
      axios.get(`/invoices/customerLoadMore/${this.customerId}/${this.count}.json?token=${this.token}`)
        .then((response) => {
          this.invoices = this.invoices.concat(response.data.invoices);
          this.count += 10;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reorderDate() {
      const reOrdered = this.orderedInvoices.reverse();
      this.orderedInvoices = reOrdered;
    },
  },
  mounted() {
    this.loadInvoices();
  },
};
</script>
